import { type BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { createAxiosInstance } from '../../api'
import { GrantWorkData, WorkData, WorkSearchRequest } from '../../types'

export const apiCrossrefBaseQuery =
  (): BaseQueryFn<
    {
      url: string
      method: AxiosRequestConfig['method']
      data?: AxiosRequestConfig['data']
      params?: AxiosRequestConfig['params']
      headers?: AxiosRequestConfig['headers']
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    const api = createAxiosInstance(`${String(process.env.REACT_APP_ENGINE_API_URL)}/reporting/crossref`)

    try {
      const result = await api(url, {
        method,
        data,
        params,
      })
      return { data: result.data }
    } catch (axiosError) {
      const err = axiosError as AxiosError
      return {
        error: { status: err.response?.status, data: err.response?.data },
      }
    }
  }

export const crossrefApi = createApi({
  reducerPath: 'crossrefApi',
  baseQuery: apiCrossrefBaseQuery(),
  endpoints: (builder) => ({
    searchWork: builder.mutation<WorkData[], { request: WorkSearchRequest }>({
      query({ request }) {
        return {
          url: `/search`,
          method: 'post',
          data: request,
        }
      },
    }),
  }),
})

export const { useSearchWorkMutation } = crossrefApi
